import { render, staticRenderFns } from "./BusinessPaymentMethods.vue?vue&type=template&id=6b673fe2&"
import script from "./BusinessPaymentMethods.vue?vue&type=script&lang=js&"
export * from "./BusinessPaymentMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports